import style from './style.module.css'
import ModalAnimal from "../../Modals/ModalInfoAnimal";

export default function Animals(props){
    return(
        <div className={style.animals}>
            <div className={style.animals_body}>
                <div className={style.animals_img}>
                    <img src={props.img} alt=""  />
                </div>
                <div className={style.btn_div}>
                    <ModalAnimal idAnimal={props.animalId}>
                        <button className={style.animals_btn}>{`CONHEÇA ${props.sex == "male" ? "O" : "A"} `} {props.name}</button>
                    </ModalAnimal>
                </div>
            </div>
        </div>     
    )
}  